// extracted by mini-css-extract-plugin
export default {"table__date":"styles_table__date__9PZSr","table__fee":"styles_table__fee__fSs2V","table__amount":"styles_table__amount__+KXGf"};